import { IMdCmFields } from "../types/AppTypes";
import { MdEnableStatusEnum } from "../types/AppEnums";
import Storage from "good-storage"
//系统标识  测试和生产主数据标识区别
export const CLIENT_APP_CODE = "threelnspection";

export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_FIRST_PAGE_NUM = 1;
export const DEFAULT_REQUEST_TIMEOUT = 300000;

//API请求环境
const baseRequestUrl = {
	"DEV": "https://api.peijian88.cn",
	"STAGE": "https://api.beiben88.com",
	// "TEST": "https://api-2.laoniuche.cn",
	"TEST": "http://test-tlpt.laoniuche.cn",
	// "TEST": "https://192.168.110.121:8084",
	// "PROD": "https://api-2.yunhaogroup.com"
	"PROD": "https://tlpt.yunhaogroup.com"

}
//API请求环境
const oldBaseRequestUrl = {
	"DEV": "https://api.peijian88.cn",
	"STAGE": "https://api.beiben88.com",
	"TEST": "https://test-api-2.laoniuche.cn",
	// "TEST": "https://192.168.110.121:9059",
	"PROD": "https://api-2.yunhaogroup.com"
}
const baseWSRequestUrl = {
    DEV: `ws://api.peijian88.cn/tco`,
    TEST: `ws://test.tco.websocket.laoniuche.cn/tco`,
    PROD: 'ws://tco.websocket.yunhaogroup.com/tco',
}

//财务的请求环境
const baseFmsRequestUrl = {
	"TESTAPI": "https://test-api-2.laoniuche.cn",
	"DEV": "https://api.peijian88.cn",
	"TEST": "https://test-api-2.laoniuche.cn",
	"PROD": "https://api-2.yunhaogroup.com",
	"STAGE": "https://api.beiben88.com"
}
const baseCiRequestUrl = {
	TESTAPI: `https://test.api.yunhaochefu.com`,
	DEV: `https://test.api.yunhaochefu.com`,
	TEST: `https://test.api.yunhaochefu.com`,
	PROD: 'https://api.yunhaochefu.com',
	STAGE: 'https://test.api.yunhaochefu.com',

};

//根据环境变量自动获取图片查看地址
export const getBaseImgLookUrl = (md5: string) => {
    //自动选择环境
    // return `${getBaseRequestUrl()}/fsrv/fetch/${md5}?Authorization=${getToken()}`
	return `${oldGetBaseRequestUrl()}/fsrv/fetch/${md5}?Authorization=${getToken()}`
}
//根据环境变量自动获取图片上传地址
export const getBaseImgUploadUrl = () => {
    //自动选择环境
    return `${oldGetBaseRequestUrl()}/fsrv/upload_file?Authorization=${getToken()}`
}
export const getBaseWSRequestUrl = () => {
    //自动选择环境
    //....
    const REACT_APP_ENV = process.env.REACT_APP_ENV as 'DEV' | 'TEST' | 'PROD'
    return baseWSRequestUrl[REACT_APP_ENV ?? 'DEV']
}
//根据环境变量自动获取图片上传地址
export const getBaseUploadData = () => {
    return {
        appCode: CLIENT_APP_CODE,
        fileMode: 0,
    }
}
//根据环境变量自动获取请求地址
export const oldGetBaseRequestUrl = () => {
	//自动选择环境
	//....
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
	return oldBaseRequestUrl[REACT_APP_ENV ?? "DEV"]
};
//根据环境变量自动获取请求地址
export const getBaseRequestUrl = () => {
	//自动选择环境
	//....
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
	return baseRequestUrl[REACT_APP_ENV ?? "DEV"]
};
//根据环境变量自动获取请求地址
export const getBaseFmsRequestUrl = () => {
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE" | "TESTAPI";
	return baseFmsRequestUrl[REACT_APP_ENV ?? "DEV"]
};
//根据环境变量自动获取请求地址
export const getBaseCiRequestUrl = () => {
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE" | "TESTAPI";
	return baseCiRequestUrl[REACT_APP_ENV ?? "DEV"]
};

//服务器自定义错误码
export const INTERNAL_SERVER_ERROR_CODE = 500;
//token存储KEY值
export const TOKEN_KEY = "auth_token";

//获取token
// export const getToken = () => {
// 	return sessionStorage.getItem(TOKEN_KEY) ?? "default-token-str"
// };
export function getToken() {
    return Storage.session.get(TOKEN_KEY)
}
//存储token
export const setToken = (token: string) => {
	sessionStorage.setItem(TOKEN_KEY, token)
};
//通用字段定义
//通用字段定义
export const defaultMdCmParam: IMdCmFields = {
	 sourceApp: "threelnspection",
	 sourceAuthKey: "",
	 branch: "threelnspection",
	 ver: undefined,
	 enable: MdEnableStatusEnum.ENABLE,
	};

export const branchDs = [
	{ label: "财务分支", value: "fms" },
	{ label: "主分支", value: "main" },
]
